import React from 'react';

// Case colours shared by +Akk badges and inline object slots (WordHeaderSlot).
export const getCaseColor = (caseValue) => {
  const caseType = String(caseValue || '').toLowerCase();
  switch (caseType) {
    case 'nominative':
    case 'nominativ':
      return 'var(--der)';
    case 'accusative':
    case 'akkusativ':
      return 'var(--der)';
    case 'dative':
    case 'dativ':
      return 'var(--das)';
    case 'genitive':
    case 'genitiv':
      return 'var(--ink-700)';
    case 'accusative/dative':
    case 'dative/accusative':
    case 'akkusativ/dativ':
    case 'dativ/akkusativ':
      return 'var(--die)';
    default:
      return 'var(--ink-700)';
  }
};


const WordHeaderCase = ({ caseValue, className = '' }) => {
  if (!caseValue) return null;

  const normalized = caseValue.toLowerCase();
  const getCaseAbbreviation = (caseType) => {
    switch (caseType) {
      case 'nominative':
      case 'nominativ':
        return '+Nom';
      case 'accusative':
      case 'akkusativ':
        return '+Akk';
      case 'dative':
      case 'dativ':
        return '+Dat';
      case 'genitive':
      case 'genitiv':
        return '+Gen';
      case 'accusative/dative':
      case 'dative/accusative':
      case 'akkusativ/dativ':
      case 'dativ/akkusativ':
        return '+Akk/Dat';
      default:
        return `+${caseValue}`;
    }
  };

  return (
    <span className={`${className} font-semibold`} style={{ color: getCaseColor(normalized) }}>
      {getCaseAbbreviation(normalized)}
    </span>
  );
};

export default WordHeaderCase;
